<template>
  <div class="bottom-area align-bottom w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="col-2 text-center">
          <router-link :to="{ name: 'Home' }">
            <img src="/static/img/match-icon.svg" class="pt-4" />
          </router-link>
        </div>
        <div class="col-2 text-center">
          <router-link :to="{ name: 'FanClub' }">
            <img src="/static/img/fan-icon.svg" class="pt-4" />
          </router-link>
        </div>
        <div class="col-4 text-center">
          <router-link :to="{ name: 'Home' }">
            <img src="/static/img/bottom-logo.svg" class="footer-logo pb-2" />
          </router-link>
        </div>
        <div class="col-2 text-center">
          <router-link :to="{ name: $store.getters.isLogged ? 'Account' : 'Login' }">
            <img src="/static/img/user-icon.svg" class="pt-4" />
          </router-link>
        </div>
        <div class="col-2 text-center">
          <a @click="toggleMenu">
            <img src="/static/img/menu-icon.svg" class="pt-4" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Footer",
  methods: {
    toggleMenu() {
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open");
      } else {
        $("body").addClass("menu-open");
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue